module.exports = __webpack_public_path__ + "img/warning.78b0f91b.svg";